import type { DashboardDefensorRelatorioDto } from '@/api.types';
import { TipoLotacao } from '@/modules/business/lotacoes/enums/tipo-lotacao.enum';
import { TipoPeriodoDescanso } from '@/modules/business/periodo/enums/tipo-periodo-descanso.enum';
import { TipoLotacaoCompletaList, TipoPeriodoDescansoList } from '@/shared/constants/enumlist';
import Links from '@/shared/constants/navegacao';

const MESES: Record<number, string> = {
  1: 'janeiro',
  2: 'fevereiro',
  3: 'março',
  4: 'abril',
  5: 'maio',
  6: 'junho',
  7: 'julho',
  8: 'agosto',
  9: 'setembro',
  10: 'outubro',
  11: 'novembro',
  12: 'dezembro',
};

export function rotuloTipoLotacao(tipo: number): string {
  return TipoLotacaoCompletaList.find((item) => item.value === tipo)?.name
    ?? TipoLotacao[tipo]
    ?? 'Lotação';
}

export function rotuloTipoPeriodo(tipo: number): string {
  return TipoPeriodoDescansoList.find((item) => item.value === tipo)?.name
    ?? (tipo === TipoPeriodoDescanso.Afastamento ? 'Afastamento' : 'Evento');
}

export function formatarDataPtBr(data: string | Date): string {
  const d = data instanceof Date ? data : new Date(data);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function rotuloMesRelatorio(mes: number): string {
  return MESES[mes] ?? String(mes);
}

export function textoRelatorioHome(item: DashboardDefensorRelatorioDto): string {
  const mes = rotuloMesRelatorio(item.mes);
  const partes: string[] = ['Relatório'];
  if (item.detalharTipo && item.tipo) {
    partes.push(item.tipo === 'criminal' ? 'criminal' : 'cível');
  }
  partes.push(`de ${mes}`);
  if (item.detalharUnidade && item.defensoriaNome) {
    partes.push(`(${item.defensoriaNome})`);
  }

  const prefixo = partes.join(' ');
  if (item.situacao === 'nao_enviado') return `${prefixo} ainda não enviado.`;
  if (item.situacao === 'em_preenchimento') return `${prefixo} já em preenchimento.`;
  if (item.situacao === 'aguardando_diretoria') return `${prefixo} aguardando aprovação da Diretoria.`;
  if (item.situacao === 'aguardando_corregedoria') {
    return `${prefixo} aprovado pela Diretoria, aguardando a Corregedoria.`;
  }
  return `${prefixo} devolvido para correção.`;
}

/** Relatórios em tramitação não são editáveis pelo defensor: abrem em visualização. */
const SITUACOES_SOMENTE_LEITURA = new Set<DashboardDefensorRelatorioDto['situacao']>([
  'aguardando_diretoria',
  'aguardando_corregedoria',
]);

export function hrefRelatorioHome(item: DashboardDefensorRelatorioDto): string {
  if (item.relatorioId && item.defensoriaId && item.mes && item.ano) {
    const params = new URLSearchParams({
      id: String(item.relatorioId),
      defensoriaId: String(item.defensoriaId),
      defensoriaName: item.defensoriaNome || '',
      mes: String(item.mes).padStart(2, '0'),
      ano: String(item.ano),
      tipo: item.tipo || 'civil',
    });
    if (SITUACOES_SOMENTE_LEITURA.has(item.situacao)) {
      params.set('view', 'true');
    }
    return `${Links.Relatorios_Criar}?${params.toString()}`;
  }
  if (item.defensoriaId && item.mes && item.ano) {
    const params = new URLSearchParams({
      defensoriaId: String(item.defensoriaId),
      defensoriaName: item.defensoriaNome || '',
      mes: String(item.mes).padStart(2, '0'),
      ano: String(item.ano),
      tipo: item.tipo || 'civil',
    });
    return `${Links.Relatorios_Criar}?${params.toString()}`;
  }
  return Links.Relatorios;
}

export function hrefFolhaHome(folhaId: string): string {
  return `${Links.Folha_Frequencia_Editar}/${folhaId}`;
}
